import type { FC } from 'react';

import {
  SkeletonBodyCopy,
  SkeletonHeadline,
  SkeletonProfileImage,
} from '@xing-com/skeleton';

import * as Styled from './top-company-card.styles';

export const TopCompanyCardSkeleton: FC = () => {
  return (
    <Styled.SkeletonCard>
      <Styled.SkeletonProfileLink>
        <SkeletonProfileImage size="xlarge" />
      </Styled.SkeletonProfileLink>
      <Styled.SkeletonMainArea>
        <SkeletonBodyCopy amountRows={1} />
        <SkeletonHeadline size="medium" amountRows={1} />
        <SkeletonBodyCopy amountRows={1} />
        <SkeletonBodyCopy amountRows={1} />
      </Styled.SkeletonMainArea>
      <Styled.SkeletonDescriptionContainer>
        <SkeletonBodyCopy amountRows={1} />
      </Styled.SkeletonDescriptionContainer>
      <Styled.SkeletonButton size="medium" />
    </Styled.SkeletonCard>
  );
};
